// The Bench tool on a standalone sauna bench: its corner nodes, where the seat
// is mitred and one segment's frame runs through under it — a click swaps
// which (`benchFrameSwaps`). docs/claude/benches.md, *Corner joins*.
import {
  type ProductInstance,
  type Vec2,
} from '../../shared/types';
import {
  nodeBenchJoints,
  nodeFrameWinner,
  toggleNodeFrameSwap,
} from '../benchSolids';
import {
  flashToolStatus,
  instLocked,
  invalidate,
  pushHistory,
  renderProperties,
  state,
} from './core';
import { pointInPolygon } from '../geometry';
import { tr } from '../i18n';
import { selectOne } from '../selection';
import {
  deselectAll,
  instancesAt,
} from '../main';

/** The corner node of an editable standalone sauna bench under `world` (the
 *  topmost), with its highlight. */
export function nodeBenchJointAt(world: Vec2): { inst: ProductInstance; node: number; polys: Vec2[][] } | null {
  for (const id of instancesAt(world, false)) {
    const inst = state.drawing.instances.find((i) => i.id === id);
    if (!inst || inst.category !== 'saunabench' || instLocked(inst)) continue;
    const j = nodeBenchJoints(inst).find((x) => x.polys.some((p) => pointInPolygon(world, p)));
    if (j) return { inst, ...j };
  }
  return null;
}

/** The Bench tool's press on a standalone bench's corner: swap whose frame
 *  runs through there. False where there is none under it. */
export function downNodeBenchJoint(world: Vec2): boolean {
  const t = nodeBenchJointAt(world);
  if (!t) return false;
  pushHistory();
  toggleNodeFrameSwap(t.inst, t.node);
  deselectAll();
  selectOne(state, 'instance', t.inst.id);
  flashToolStatus(nodeFrameWinner(t.inst, t.node) === t.node
    ? tr('Frame: the segment after the corner runs through')
    : tr('Frame: the segment before the corner runs through'));
  renderProperties();
  invalidate();
  return true;
}
